

import { Component, Vue, Prop } from "vue-property-decorator"

import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import FieldAndValue from "@/components/Controls/FieldAndValue.vue"

import { CurrentUser } from "@/types/user"
import ScheduleSetting from "@/types/scheduleSettings"

import apiScheduleSettings from "@/services/api_ScheduleSettings"
import ScheduleEditService from "@/services/scheduleEditService"
import FolderSetup from "../Folders/FolderSetup.vue"
import { Folder, FolderType } from "@/types/folder"
import { Team } from "@/types"
import { Getter } from "vuex-class"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"skeleton": SkeletonLoader,
		"field-and-value": FieldAndValue,
		"folder-setup": FolderSetup
	}
})
export default class ScheduleSettings extends Vue {
	@Prop()
	scheduleSettings!: ScheduleSetting

	@Prop({ type: Object, default: () => {} })
	folders!: { [title:string]:Folder }

	@Prop({ type: Array, default: () => [] })
	teams!: Team[]

	@Getter("getMe")
	public me!: CurrentUser;

	private scheduleEditService = new ScheduleEditService()
	private folderList: Folder[] = []

	FolderType = FolderType

	private isLoadingMisc = false

	public async mounted () {
		await this.scheduleEditService.load(this.me)

		this.folderList = Object.values(this.folders)
	}

	private async saveSettings () {
		try {
			await apiScheduleSettings.ScheduleSettingsSave(this.scheduleSettings!)
			this.$bvToast.toast("Schedule settings saved.", {
				title: "Success",
				variant: "success",
				solid: true,
				autoHideDelay: 5000
			})
		} catch (e) {
			this.$bvToast.toast(`Schedule settings failed to save. Reason: ${e}`, {
				title: "Error",
				variant: "danger",
				solid: true,
				autoHideDelay: 5000
			})
		}
	}

	private closeSettings () {
		this.$emit("return")
	}
}
